import { object } from '@iwentsourcing/core/typing/object.js';
import { array } from '@iwentsourcing/core/typing/array.js';
import { BrowseItem } from './browse-item.js';
import { StateValue } from '@iwentsourcing/core/storage/state-value.js';
import { record } from '@iwentsourcing/core/typing/record.js';
import { string } from '@iwentsourcing/core/typing/string.js';
import { nullable } from '@iwentsourcing/core/typing/nullable.js';

export const IndexBrowseResult = object('IndexBrowseResult', {
  items: array(BrowseItem),
  bookmark: nullable(record(string(), StateValue)),
});
